var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeAwayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.664,
    height: 141.734,
    viewBox: "0 0 135.664 141.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TAKEAWAY_icon",
    "data-name": "TAKEAWAY icon",
    transform: "translate(-6.077 -5.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "svgFill",
    d: "M108.819,10.3A27.955,27.955,0,0,0,94.662,5.633H53.155A27.91,27.91,0,0,0,39.005,10.3L6.077,34.617H141.741Zm-6.952,9.878A3.928,3.928,0,0,1,97.944,24.1H49.888a3.924,3.924,0,0,1-3.924-3.924V17.9a3.924,3.924,0,0,1,3.924-3.924H97.944a3.928,3.928,0,0,1,3.924,3.924Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "svgFill",
    d: "M6.077,111.58A3.928,3.928,0,0,0,10,115.5H137.824a3.927,3.927,0,0,0,3.917-3.924V11.093H6.077ZM87.792,26.173c6.091,0,11.026,8.818,11.026,17.076,0,5.728-2.42,9.632-5.906,11.5V97.512a2.929,2.929,0,0,1-2.926,2.926H85.6a2.92,2.92,0,0,1-2.926-2.926V54.747c-3.5-1.866-5.906-5.769-5.906-11.5C76.78,34.991,81.715,26.173,87.792,26.173ZM49,26.173h4.518V39.011h2.851V26.173h4.518V39.011h2.857V26.173h4.518V52.744H63.744V97.512a2.929,2.929,0,0,1-2.926,2.926H56.437a2.92,2.92,0,0,1-2.926-2.926V52.744H48.992V26.173Z",
    transform: "translate(0 31.864)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAwayIcon);
export default __webpack_public_path__ + "static/media/takeAwayIcon.3b659df2ec55e6dd6f10108875af8fd9.svg";
export { ForwardRef as ReactComponent };